import { render, staticRenderFns } from "./pphhutang.vue?vue&type=template&id=89d4e052"
import script from "./pphhutang.vue?vue&type=script&lang=js"
export * from "./pphhutang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports